import {ajax, formatToServerDate} from '../../common/utils.js';
import {SET_SIGNUP_DATA, CLEAR_SIGNUP_DATA, SET_SHARES_DATA,
    SET_DELIVERY_DAY_FILTER, ADD_ITEM,
    SELECT_PAYMENT_PLAN, SET_COUPON, REMOVE_COUPON,
    GOTO_STEP, CONTACT_INFO_STEP, SET_MAP_PROPS, INIT_MAP_PROPS,
    JOIN_CHANGE_ITEM_QUANTITY, JOIN_SET_ITEM_SCHEDULE,
    CLEAR_SHARES_SELECTION, SET_SELECTED_METHOD, SET_SIGNUP_COMMENTS, SET_TERMS_SELECTED, SET_HOME_DELIVERY_INSTRUCTIONS,
    SET_INVALID_OPTION_SCHEDULE_MESSAGE, SET_COUPON_STATUS} from "../actionTypes";
import {fetchingData, dataFetched, errorFetching} from "../common/fetchingActions";
import {FetchingTypes, JoinSteps, JoinStepsDirections,
    JoinCreateAccountConstants, JoinModes, URLs, MemberActions, CouponStatus} from '../../common/constants';
import {submitSubscription} from "./joinPayActions";
import {setDirty, getCouponData} from "../common/commonActions";
import {redirectPage} from "../../common/utils";
import {createGuestSubscription, isCreatingSubscription} from "../common/subscriptionSummaryActions";
import {getSubscriptionStatus, resetEmailSent} from "../../actions/login/logInActions";
import {messageDataParser, setMessageData} from "../common/messagePageActions";
import {setMemberAction} from "../login/memberDetailsActions";
import {translate} from "../../i18n/translate";
import {getDistributionsNumber, getItemPrice} from "../../common/basket";

export function setSignupData(signupData) {
    return {
        type: SET_SIGNUP_DATA,
        signupData
    };
}

export function clearSignupData() {
    return {
        type: CLEAR_SIGNUP_DATA
    }
}

function setSharesData(sharesData, key) {
    return {
        type: SET_SHARES_DATA,
        sharesData,
        key
    };
}

export function setPickupSitesFilters(deliveryDay) {
    return {
        type: SET_DELIVERY_DAY_FILTER,
        deliveryDay: deliveryDay
    };
}

export function setMapProps(zoomLevel, centerLocation) {
    return {
        type: SET_MAP_PROPS,
        zoomLevel,
        centerLocation
    };
}

export function initMapProps() {
    return {
        type: INIT_MAP_PROPS
    };
}

export function addItem(key){
    return {
        type: ADD_ITEM,
        key: key
    }
}

export function selectPaymentPlan(key){
    return {
        type: SELECT_PAYMENT_PLAN,
        key: key
    }
}

export function setPastSeasonMessage(){
    return function (dispatch, getState){
        const messageData = messageDataParser({}, {staticData: getState().staticData, flowType: URLs.JOIN});
        dispatch(setMessageData(messageData));
    }
}

export function applyCoupon(couponId){
    return function(dispatch){
        if(couponId === ""){
            dispatch(setCoupon(undefined));
        } else {
            dispatch(getCouponData(couponId, setCoupon));
        }
    }
}

function setCoupon(couponData) {
    return {
        type: SET_COUPON,
        coupon: couponData
    }
}

export function removeCoupon(){
    return {
        type: REMOVE_COUPON
    }
}

export function setCreateAccountPage(contactInfoPage) {
    return {
        type: CONTACT_INFO_STEP,
        contactInfoPage: contactInfoPage
    }
}

export function getStepLabel(step, pickupSiteLabel, isWaitListOnly, isGuestUser, joinSharesStepLabel){
    switch (step) {
        case (JoinSteps.PICKUP_SITES):
            return (!pickupSiteLabel || pickupSiteLabel === 'null') ? "Pick-Up Site" : pickupSiteLabel;
        case (JoinSteps.SHARES):
            return isWaitListOnly ? " Waitlist" : ((!joinSharesStepLabel || joinSharesStepLabel === 'null') ? "Shares": joinSharesStepLabel);
        case (JoinSteps.OPTIONS):
            return "Options";
        case (JoinSteps.TERMS):
            return "Terms";
        case (JoinSteps.CONTACT_INFO):
            return "Contact Info";
        case (JoinSteps.PAY):
            return "Pay";
        case (JoinSteps.FINISH):
            return !isGuestUser ? "Finish" : "Start Shopping";
        default:
            return "";
    }
}

export function navigateToStep(direction) {
    return function(dispatch, getState) {
        const state = getState();
        const signupData = state.signupData;
        const login = state.loginStatus;
        const steps = signupData.steps;
        const summary  = (state.summary || {});
        const staticData = state.staticData;
        let stepIndex = steps.indexOf(signupData.step);
        let step = signupData.step;

        if (step === JoinSteps.OPTIONS && direction === JoinStepsDirections.NEXT &&
                state.staticData.syncOptionSchedules){
            let sharesData = Object.assign({},signupData.sharesData,
                {shares: Object.assign({}, signupData.sharesData.shares),
                    options: Object.assign({}, signupData.sharesData.options)});
            (summary.shareItems || []).map(function (sharesData, item, index) {
                sharesData.shares[item.key] = Object.assign({},item, {selectedSchedule: summary.shareSchedules[index]});
            }.bind(summary, sharesData));
            const validationMessage = isValidOptionScheduleMessage(sharesData, signupData.schedules);
            if(validationMessage) {
                dispatch(setInvalidOptionSchedulesMessage(validationMessage));
                return;
            }
        }
        if (step === JoinSteps.TERMS && direction === JoinStepsDirections.NEXT){
            const coupon = (signupData.selectedData || {}).coupon;
            if(coupon && !isValidateCouponMinimum(coupon, signupData.sharesData, staticData)){
                dispatch(setCouponStatus(CouponStatus.INVALID_COUPON_MINIMUM));
                return;
            } else if(coupon && coupon.status) {
                dispatch(setCouponStatus(undefined));
            }
        }
        if (step === JoinSteps.PAY && direction === JoinStepsDirections.NEXT){
            dispatch(submitSubscription());
            if (state.clientViewPort && state.clientViewPort.isXs)
                scrollStepToTop();
            return;
        }
        if (direction === JoinStepsDirections.BACK) {
            if (step === JoinSteps.CONTACT_INFO) {
                if(signupData.contactInfoPage && signupData.contactInfoPage === JoinCreateAccountConstants.LOGIN
                    && login.isForgetPassword) {
                    dispatch(resetEmailSent());
                    return;
                }
                if(signupData.contactInfoPage && signupData.contactInfoPage === JoinCreateAccountConstants.CONTACT_DETAILS
                    && !(state.staticData.facebookId || state.memberDetails.key)) {
                    dispatch(setCreateAccountPage(JoinCreateAccountConstants.CREATE_CONTACT));
                    return;
                } else if(stepIndex === 0){
                    window.location.assign(redirectPage(URLs.STORE, state.staticData));
                    return;
                }
            } else if (step === JoinSteps.TERMS) {
                dispatch(setCreateAccountPage(JoinCreateAccountConstants.CONTACT_DETAILS));
            }
        }
        if (stepIndex === 0 && direction === JoinStepsDirections.BACK){
            //Add Subscription flow - need to get back to the store
            window.history.back();
            return;
        }
        if (direction === JoinStepsDirections.NEXT) {
            stepIndex++;
        } else if (direction === JoinStepsDirections.BACK) {
            stepIndex--;
        }
        if (stepIndex >= 0 && stepIndex <= steps.length - 1)
            step = steps[stepIndex];
        //Check if need to load shares
        if (direction === JoinStepsDirections.NEXT) {
            if (step === JoinSteps.SHARES && (state.summary.pickupSite || {}).key !== signupData.sharesData.pickupSiteKey) {
                dispatch(getSharesData((state.summary.pickupSite || {}).deliveryDays, (state.summary.pickupSite || {}).key, JoinModes.NEW));
            }
            if (!signupData.isGuestUser && !signupData.isAddSubscription && step === JoinSteps.PAY
                || ((signupData.data || {}).isWaitListOnly && step === JoinSteps.FINISH)
                    || (signupData.isGuestUser && step === JoinSteps.PICKUP_SITES)) {
                dispatch(setMemberAction(MemberActions.VALIDATE_MEMBER_DETAILS));
                return;
            } else if(signupData.isGuestUser && step === JoinSteps.FINISH) {
                dispatch(isCreatingSubscription(true));
                dispatch(setDirty(false));
                dispatch(createGuestSubscription(state.memberDetails.key, state.summary.pickupSite.key));
                return;
            }
        }
        dispatch(gotoStep(step));
        //On mobile scroll to top of the page
        if (state.clientViewPort && state.clientViewPort.isXs)
            scrollStepToTop();
    }
}
export function isValidOptionScheduleMessage(sharesData, schedules, storeAccessShareShare) {
    let sharesSelectedSchedules = [];
    for (let key in sharesData.shares) {
        if (key === storeAccessShareShare) {
            continue;
        }
        if (sharesData.shares.hasOwnProperty(key)) {
            const share = sharesData.shares[key];
            if (share.quantity > 0 && share.selectedSchedule) {
                const shareSchedules = schedules[share.selectedSchedule];
                sharesSelectedSchedules = sharesSelectedSchedules.concat(shareSchedules.dates);
            }
        }
    }
    let invalidOptions = {};
    let hasInvalid = 0;
    for (let key in sharesData.options) {
        if (sharesData.options.hasOwnProperty(key)) {
            const option = sharesData.options[key];
            if (option.quantity > 0 && option.selectedSchedule && schedules.hasOwnProperty(option.selectedSchedule)) {
                const optionSchedules = schedules[option.selectedSchedule];
                const today = formatToServerDate(new Date());
                if (!optionSchedules.dates.every(function (date) {
                        if (today < date) {
                            return sharesSelectedSchedules.indexOf(date) >= 0;
                        } else {
                            return true;
                        }
                    })) {
                    if (!invalidOptions.hasOwnProperty(option.selectedSchedule)) {
                        invalidOptions[option.selectedSchedule] = [];
                    }
                    invalidOptions[option.selectedSchedule].push(option.title);
                    hasInvalid++;
                }
            }
        }
    }
    if (hasInvalid > 0) {
        const key = Object.keys(invalidOptions)[0];
        if (schedules.hasOwnProperty(key)) {
            const invalidOptionsArray = invalidOptions[key];
            let options = invalidOptionsArray[0];
            for (let i = 1; i < invalidOptionsArray.length; i++) {
                options += ", " + invalidOptionsArray[i];
            }
            return translate("_syncOptionSchedulesValidation").replace("{0}", options);
        }
    }
    return undefined;

}

export function setInvalidOptionSchedulesMessage(invalidOptionScheduleMessage) {
    return {
        type: SET_INVALID_OPTION_SCHEDULE_MESSAGE,
        invalidOptionScheduleMessage
    }
}
function scrollStepToTop(){
    window.scrollTo(0, 0);
}

export function gotoStep(step){
    return {
        type: GOTO_STEP,
        step: step
    }
}

export function getSignupData(mode){
    return function(dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/SignupService.getSignupData';
        let data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey
        };
        if (mode === JoinModes.CHANGE || mode === JoinModes.ADD)
            data.pickupSiteKey = state.summary.pickupSite.key;
        dispatch(fetchingData(FetchingTypes.LOAD_SIGNUP_DATA));
        return ajax(fetchUrl, data)
            .then(json => signupParser(json, mode))
            .then(signupData => {
                dispatch(setSignupData(signupData));
                if (signupData.data.isWaitListOnly) {
                    dispatch(getWaitListShareItems());
                }
                dispatch(gotoStep(signupData.steps[0]));
                //case of change or add subscription
                if (mode === JoinModes.CHANGE || mode === JoinModes.ADD)
                    dispatch(getSharesData(state.summary.pickupSite.deliveryDays, state.summary.pickupSite.key, mode));
                else if (state.memberDetails.key)
                    dispatch(getSubscriptionStatus(state.memberDetails.key));
                else
                    dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(errorFetching(error, {action:getSignupData, args:[mode]}));
            })
    }
}

function signupParser(json, mode) {
    const data = {
        hasCoupons: json.hasCoupons,
        hasOptions: json.hasOptions,
        isFarmSeasonal: json.isFarmSeasonal,
        isWaitListOnly: json.isWaitListOnly,
        seasonTitle: json.seasonTitle
    };
    let steps;
    if (mode === JoinModes.CHANGE) {
        steps = data.hasOptions ? [JoinSteps.SHARES, JoinSteps.OPTIONS] : [JoinSteps.SHARES];
    } else if (mode === JoinModes.ADD) {
        steps = [JoinSteps.SHARES, JoinSteps.OPTIONS, JoinSteps.TERMS, JoinSteps.PAY, JoinSteps.FINISH];
        if (!data.hasOptions)
            steps.splice(1, 1);
    } else if (data.isWaitListOnly) {
        steps = [JoinSteps.SHARES, JoinSteps.CONTACT_INFO, JoinSteps.FINISH];
    } else {
        steps = [JoinSteps.PICKUP_SITES, JoinSteps.SHARES, JoinSteps.OPTIONS, JoinSteps.TERMS, JoinSteps.CONTACT_INFO, JoinSteps.PAY, JoinSteps.FINISH];
        if (!data.hasOptions)
            steps.splice(2, 1);
    }
    return {
        data: data,
        steps: steps,
        pickupSitesData: parsePickupSiteData(json),
        paymentMethods: parsePaymentMethods(json),
        paymentPlans: parsePaymentPlans(json),
        schedules: parseSchedules(json),
        shareSchedules: parseShareSchedules(json),
        isAddSubscription: mode === JoinModes.ADD
    }
}

function parsePickupSiteData(json) {
    return json.pickupSitesData;
}

function parsePaymentMethods(json) {
    return json.paymentMethods;
}

function parsePaymentPlans(json) {
    //Keep only the one relevant for signup
    return json.paymentPlans.filter(plan => {
        return plan.isActive && plan.isSignup
    });
}

function parseSchedules(json) {
    return json.schedules;
}

function parseShareSchedules(json) {
    return json.shareSchedules;
}

function getSharesData(day, pickupSiteKey, mode){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/SignupService.getShareItems';
        let data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey,
            day: day,
            isSignup: mode === JoinModes.NEW
        };
        if (mode === JoinModes.CHANGE || mode === JoinModes.ADD)
            data.subscriptionKey = state.summary.key;
        dispatch(fetchingData(FetchingTypes.LOAD_SIGNUP_SHARES));
        return ajax(fetchUrl, data)
            .then(json => sharesParser(json, state))
            .then(sharesData => {
                if (mode === JoinModes.CHANGE || mode === JoinModes.ADD)
                    return mergeSharesDataWithSummary(sharesData, state.summary, mode);
                else
                    return sharesData;
            })
            .then(sharesData => dispatch(setSharesData(sharesData, pickupSiteKey)))
            .then(() => dispatch(dataFetched()))
            .catch(error => {
                dispatch(errorFetching(error, {action:getSharesData, args:[day, pickupSiteKey, mode]}));
            })
    }
}

function sharesParser(json, state) {
    //Create a set of all remaining dates
    let items = {};
    let shares = {};
    let options = {};
    const pickupSite = state.summary.pickupSite;
    const isWaitListOnly = state.signupData.data.isWaitListOnly;
    json.shareItems.map((item) => {
        items[item.key] = item;
        item.quantity = 0;
        item.orderedQuantity = 0;
        item.waitList = (item.capacity - item.usageCount) <= 0;
        item.description = item.description?item.description.replace(/\r/g,'<br>'):'';
        if (!isWaitListOnly) {
            const pickupSiteKey = pickupSite.key;
            let selectedSchedule = item.pickupSiteScheduleMap.hasOwnProperty(pickupSiteKey) ? item.pickupSiteScheduleMap[pickupSiteKey] : -1; //if -2 then no deliveries for this schedule
            if (item.isAvailable && (item.defaultSchedulesSize <= 1 || item.weeksLeft === null)) {
                if (selectedSchedule === -1 && item.defaultSchedulesSize === 1) {
                    selectedSchedule = 0;
                }
            }
            if (selectedSchedule >= 0) {
                item.schedules = [item.schedules[selectedSchedule]];
                item.weeksLeft = [item.weeksLeft[selectedSchedule]];
            }
            if (!item.pickupSiteNotAvailableSet.includes(pickupSiteKey) && selectedSchedule > -2) {
                if (!item.isAdditional)
                    shares[item.key] = item;
                else
                    options[item.key] = item;
            }
        } else {
            if (!item.isAdditional)
                shares[item.key] = item;
            else
                options[item.key] = item;
        }
    });

    return {
        items,
        shares,
        options,
        remainingScheduleDates: json.remainingScheduleDates
    }
}

function mergeSharesDataWithSummary(sharesData, summary, mode){
    summary.shareItems.map(item => {
        if (mode === JoinModes.ADD){
            if(sharesData.items[item.key])  {
                sharesData.items[item.key].maxPerMember -= item.quantity;
            }
        } else if (mode === JoinModes.CHANGE) {
            if (sharesData.items[item.key]){
                sharesData.items[item.key].quantity = item.quantity;
                sharesData.items[item.key].selectedSchedule = item.selectedSchedule;
                if (sharesData.items[item.key].price !== item.price) {
                    sharesData.items[item.key].price = item.price;
                    //If price was changed don't allow adding more items
                    sharesData.items[item.key].maxPerMember = item.quantity;
                }
                if (sharesData.items[item.key].waitList && item.quantity > 0) {
                    sharesData.items[item.key].waitList = false;
                    sharesData.items[item.key].maxPerMember = item.quantity;
                    sharesData.items[item.key].available = item.quantity;
                    sharesData.items[item.key].capacity = sharesData.items[item.key].usageCount + item.quantity;
                }
            } else {
                sharesData.items[item.key] = Object.assign({}, item);
                sharesData.items[item.key].maxPerMember = item.quantity;
                sharesData.items[item.key].available = item.quantity;
                sharesData.items[item.key].capacity = sharesData.items[item.key].usageCount + item.quantity;
                sharesData.items[item.key].weeksLeft = [999];
                if (!item.isAdditional)
                    sharesData.shares[item.key] = sharesData.items[item.key];
                else
                    sharesData.options[item.key] = sharesData.items[item.key];
            }
        }
    });
    summary.waitListItems.map(item => {
        if (mode === JoinModes.ADD){
            if(sharesData.items[item.key]) {
                sharesData.items[item.key].maxPerMember -= item.quantity;
            }
        } else if (mode === JoinModes.CHANGE) {
            if (sharesData.items[item.key]) {
                sharesData.items[item.key].quantity = item.quantity;
            } else {
                sharesData.items[item.key] = Object.assign({}, item);
                sharesData.items[item.key].waitList = true;
                sharesData.items[item.key].maxPerMember = 0;
                sharesData.items[item.key].available = 0;
                sharesData.items[item.key].capacity = 0;
                sharesData.items[item.key].weeksLeft = [999];
                if (!item.isAdditional)
                    sharesData.shares[item.key] = sharesData.items[item.key];
                else
                    sharesData.options[item.key] = sharesData.items[item.key];
            }

        }
    });
    return sharesData;
}

export function joinChangeItemQuantity(key, newQuantity){
    return {
        type: JOIN_CHANGE_ITEM_QUANTITY,
        key: key,
        newQuantity
    };
}
export function setSelectedSchedule(key, selectedSchedule){
    return {
        type: JOIN_SET_ITEM_SCHEDULE,
        key: key,
        selectedSchedule
    };
}

export function initGuestUser() {
    return function(dispatch) {
        let steps = [JoinSteps.CONTACT_INFO, JoinSteps.PICKUP_SITES, JoinSteps.FINISH];
        const signupData = {
            steps: steps,
            isGuestUser: true
        };
        dispatch(setSignupData(signupData));
    }
}

export function getGuestPickupSiteData(){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/SignupService.getGuestPickupSiteData';
        const data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey
        };
        dispatch(fetchingData(FetchingTypes.LOAD_PICKUP_DATA));
        return ajax(fetchUrl, data)
            .then(json => guestPickupParser(json))
            .then(signupData => {
                dispatch(setSignupData(signupData));
                dispatch(dataFetched());
            })
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}
function guestPickupParser(json) {
    return {
        pickupSitesData: parsePickupSiteData({pickupSitesData:json}),
    }
}

export function getWaitListShareItems(){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = '/dispatcher/SignupService.getWaitListShareItems';
        const data = {
            farmKey: state.staticData.farmKey,
            seasonKey: state.staticData.seasonKey
        };
        dispatch(fetchingData(FetchingTypes.LOAD_SIGNUP_SHARES));
        return ajax(fetchUrl, data)
            .then(response => waitListShareItemsParser(response))
            .then(json => sharesParser(json, state))
            .then(shareData => {
                dispatch(setSharesData(shareData));
                dispatch(gotoStep(JoinSteps.SHARES));
            }).then(()=> dispatch(dataFetched()))
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

function waitListShareItemsParser(response) {
    return {shareItems:response};
}

export function clearSharesSelection() {
    return {
        type: CLEAR_SHARES_SELECTION
    }
}

export function setSelectedMethod(key){
    return {
        type: SET_SELECTED_METHOD,
        key
    }
}

export function setComments(comments){
    return {
        type: SET_SIGNUP_COMMENTS,
        comments
    }
}

export function setTermsSelected(isSelected){
    return {
        type: SET_TERMS_SELECTED,
        isSelected
    }
}

export function setHomeDeliveryInstructions(instructions){
    return {
        type: SET_HOME_DELIVERY_INSTRUCTIONS,
        instructions
    }
}

export function isValidateCouponMinimum(coupon, sharesData, staticData) {
    if(coupon.useMinimumOrder && coupon.minimumOrder > 0) {
        let total = getShareTotal(sharesData.shares, staticData);
        if(coupon.calculateOptions) {
            total += getShareTotal(sharesData.options, staticData);
        }
        return total >= coupon.minimumOrder;
    }
    return true;
}

function getShareTotal(shares, staticData) {
    let total = 0;
    for(let shareKey in shares) {
        if(shares.hasOwnProperty(shareKey)) {
            const share = shares[shareKey];
            if(share.quantity > 0) {
                const distributionsNumber = getDistributionsNumber(share, share.selectedSchedule);
                total += share.quantity * getSharePrice(share, distributionsNumber, staticData) * distributionsNumber
            }
        }
    }
    return total;
}
function getSharePrice(share, distributionsNumber, staticData) {
    const sharePrice = getItemPrice(share, staticData);
    let calcPrice = sharePrice.priceBeforeTax;
    //Don't multiply by distributionsNumber as it is already multiplied in getShareTotal
    // if (staticData.hideDeliveryPrice) {
    //     calcPrice = share.selectedSchedule || share.schedules.length === 1 ? calcPrice * (distributionsNumber ? distributionsNumber : 1) : undefined;
    // }
    return calcPrice;
}

export function setCouponStatus(status) {
    return {
        type: SET_COUPON_STATUS,
        status
    }
}


// WEBPACK FOOTER //
// ./src/actions/join/joinActions.js